import script from "./sliderCaptcha.vue?vue&type=script&setup=true&lang=js"
export * from "./sliderCaptcha.vue?vue&type=script&setup=true&lang=js"

import "./sliderCaptcha.vue?vue&type=style&index=0&id=66575d23&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66575d23"]])

export default __exports__